import { render, staticRenderFns } from "./addOweFeeCallableList.vue?vue&type=template&id=b4e22c64&scoped=true"
import script from "./addOweFeeCallableList.vue?vue&type=script&lang=js"
export * from "./addOweFeeCallableList.vue?vue&type=script&lang=js"
import style0 from "./addOweFeeCallableList.vue?vue&type=style&index=0&id=b4e22c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e22c64",
  null
  
)

export default component.exports